import styles from './TableSkeletonRow.module.scss';

import Skeleton from '@mui/material/Skeleton';

export function TableSkeletonRow(props: React.HTMLProps<HTMLDivElement>) {
  return (
    <div style={props.style}>
      <Skeleton className={styles.skeleton} />
    </div>
  );
}
